// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"66":"textbanner","670":"credits"}[chunkId] + "." + {"66":"acbf5dae","670":"4a8aa417"}[chunkId] + ".css";
};